export default function StatTile({ label, value, hint }) {
  return (
    <div className="rounded border border-app-border bg-app-surface-alt p-3">
      <div className="text-xs uppercase tracking-wide text-app-text-secondary">{label}</div>
      <div className="mt-1 text-xl font-semibold text-app-text">{value}</div>
      {hint ? <div className="mt-0.5 text-xs text-app-text-muted">{hint}</div> : null}
    </div>
  );
}
